/**
 * useNicheFinderStats — busca contadores das abas (GET /stats).
 *
 * Cache simples em memoria por sessao — se outra parte da pagina (ex:
 * NicheFinderHeader) precisar do mesmo dado, reusa sem refetch.
 *
 * `enabled=false` permite atrasar o fetch ate a access check passar.
 */
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = (import.meta.env.VITE_BACKEND_URL || '') + '/api';

let _statsCache = null;
let _statsCacheAt = 0;
const CACHE_TTL_MS = 30 * 1000;

export function useNicheFinderStats({ enabled = true } = {}) {
  const [stats, setStats] = useState(_statsCache);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async (force = false) => {
    if (!enabled) return;
    const fresh = _statsCache && (Date.now() - _statsCacheAt) < CACHE_TTL_MS;
    if (fresh && !force) {
      setStats(_statsCache);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(`${API}/nichos-virais/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      _statsCache = data;
      _statsCacheAt = Date.now();
      setStats(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) {
      fetchStats(false);
    }
  }, [enabled, fetchStats]);

  return { stats, loading, error, refetch: () => fetchStats(true) };
}
